import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../auth/auth.api";
import { TSuccessResponse } from "@/types/general/TSuccessResponse";
import TKRA from "@/types/kra-management/TKRA";
import TPaginationParams from "@/types/general/TPaginationParams";

export const kraApi = createApi({
  reducerPath: "kraApi",
  tagTypes: ["KRA"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllKra: builder.query<
      TSuccessResponse<TKRA[]>,
      { pagination?: TPaginationParams; searchKey?: string, filter?: { year: number|string; month: number|string } }
    >({
      query: ({ pagination = {} as any, searchKey, filter }) => {
        const params: Record<any, any> = {};
        const { page = 1, limit = 100 } = pagination;

        if (page && limit) {
          params.page = page;
          params.limit = limit;
        }

        if (searchKey) {
          params.search = searchKey;
        }

        if (filter?.year) {
            params.year = filter.year;
        }

        if (filter?.month) {
            params.month = filter.month
        }

        return {
          url: "kra-management/kra",
          params: params,
        };
      },
    }),

    createKRA: builder.mutation<TSuccessResponse<null>, TKRA>({
      query: (body) => ({
        url: "kra-management/kra",
        method: "POST",
        body,
      }),
    }),

    updateKRA: builder.mutation<
      TSuccessResponse<null>,
      { kraId: number; kraDetailId: number; data: TKRA }
    >({
      query: ({ kraId, kraDetailId, data }) => ({
        url: `kra-management/kra/${kraId}/${kraDetailId}`,
        method: "PATCH",
        body: data,
      }),
    }),

    getKRA: builder.query<TSuccessResponse<TKRA>, string>({
      query: (kraId) => `kra-management/kra/${kraId}`,
    }),

    deleteKRA: builder.mutation<
      TSuccessResponse<null>,
      {
        kraId: string | number;
        detailId: string | number;
      }
    >({
      query: ({ kraId, detailId }) => ({
        url: `kra-management/kra/${kraId}/${detailId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllKraQuery,
  useCreateKRAMutation,
  useUpdateKRAMutation,
  useGetKRAQuery,
  useDeleteKRAMutation,
} = kraApi;
